const Initialarray = {
    upload: [],
    selected_category: null,
}

export default function Set_Checklist(state = Initialarray, action) {
    switch (action.type) {
        case "SET_IMAGE_CATEGORY":
            state = {
                ...state,
                upload: action.upload
            }
            break;
        case "SET_SELECTED_CATEGORY":
            state = {
                ...state,
                selected_category: action.selected_category
            }
            break;
        case "CLEAR_IMAGE_CATEGORY":
            state = {
                ...state,
                upload: [],
                selected_category: null,
            }
            break;
        default:

            break;
    }
    return state;
}